import { ENTITY_TYPE_OPTIONS } from "@/constants/entityType";
import { SelectInput, SelectInputProps } from "react-admin";

const EntityTypeSelect = (props: Omit<SelectInputProps, "choices">) => {
  const choices = ENTITY_TYPE_OPTIONS.map((option) => ({
    id: option.value,
    name: option.label,
  }));

  return <SelectInput {...props} choices={choices} />;
};

export default EntityTypeSelect;
